// Vendor Libs
import React from 'react';

// Components
import Loading from '../core/loading';
import Permissions from '../core/permissions';
import FreewheelConfigForm from './freewheel-config-form';

// Containers
import FormData from '../../containers/form-data';

const formName = 'freewheelConfig';

function FreewheelConfig() {
    return (
        <Permissions
            accessRequirement="update"
            elementService="vfb"
            notAuthorizedMessage={true}
            requiresServiceAccess={true}
        >
            <FormData formName={formName}>
                {({ resetForm, searchFetching }) => (
                    <>
                        <FreewheelConfigForm
                            {...{
                                className: 'freewheel-config',
                          editing: true,
                                onReset: (submitted, resetValues) => resetForm(submitted, resetValues, true),
                            }}
                        />
                        <Loading loading={searchFetching} />
                    </>
                )}
            </FormData>
        </Permissions>
    );
}

export default FreewheelConfig;
